module.exports = __webpack_public_path__ + "assets/img/appellation.e3d12592.svg";